import Vue from 'vue'
import ConfirmComponent from './Confirm.vue'

const ConfirmConstructor = Vue.extend(ConfirmComponent)

let currentInstance

const install = (Vue) => {
  const showConfirm = (options = {}) => {
    // 销毁之前的实例
    if (currentInstance) {
      currentInstance.vm.$destroy()
      if (currentInstance.vm.$el && currentInstance.vm.$el.parentNode) {
        currentInstance.vm.$el.parentNode.removeChild(currentInstance.vm.$el)
      }
    }

    // 处理参数
    const propsData = {
      title: options.title || '',
      content: options.content || '',
      confirmText: options.confirmText || '',
      cancelText: options.cancelText || '',
      confirm: options.confirm || (() => {}),
      cancel: options.cancel || (() => {}),
    }

    // 创建新实例
    currentInstance = new ConfirmConstructor({
      propsData,
    })

    // 挂载实例
    currentInstance.vm = currentInstance.$mount()
    document.body.appendChild(currentInstance.vm.$el)

    // 显示确认框
    currentInstance.vm.open(propsData)
    currentInstance.vm.visible = true

    return currentInstance.vm
  }

  // 注册到Vue原型
  Vue.prototype.$confirm = showConfirm
}

// 自动安装
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
}
